import { type ITooltipProps } from 'shared/ui'
import { TooltipShortcut } from 'shared/ui/Tooltip/ui/TooltipShortcut'

export const sendActionTooltipProps: ITooltipProps = {
  label: <TooltipShortcut label={'Send'} keys={['ctrl', 'Enter']} />,
  placement: 'top',
}
